import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M6 12a6 6 0 0 0 6 6","key":"svg-1"}]]

const IconInnerShadowBottomLeft = createReactComponent('outline', 'inner-shadow-bottom-left', 'InnerShadowBottomLeft', __iconNode);

export default IconInnerShadowBottomLeft;